export default __webpack_public_path__ + "static/media/Gilroy-Semibold.4b11ebb0.otf";